<template>
    <div class="leftMenuManagerWrap">
        <div class="mainContent"  v-loading="isLoadingMenu">
            <div class="treeMenuBox">
                <div class="rootLine" :class="{active:!isShowTree}" @click="addNodeFromRoot">
                    <i class="el-icon-setting"></i>
                    <span style="padding-left:20px;" >根菜单<i class="el-icon-circle-plus-outline"></i> </span>
                    <!-- <el-button  type="primary">根目录下新增</el-button> -->
                </div>
                <hr>
                <div class="rootLine " :class="{active:isShowTree}" @click="isShowTree=true">
                    <i class="el-icon-setting"></i>
                    <span style="padding-left:20px;">所有菜单</span>
                </div>
                <div class="treeBox" v-if="isShowTree">
                    <el-tree :data="allMenuData" :expand-on-click-node="false"  :default-expand-all="true"  :props="defaultProps" @node-click="handleNodeClick" :highlight-current="true">
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span :class="{black:data.menu_state=='y',grey_lighter:data.menu_state=='n'}">{{ data.menu_name}}</span>
                            <span>
                                <span class="textBtn" v-if="data.menu_state=='n'" @click="toggleMenuState(data)">启用</span>
                              <!-- <el-button   type="danger"      size="mini"        @click="() => append(data)">  Append   </el-button> -->
                              <!-- <el-button    type="warning"        size="mini"             @click="() => remove(node, data)">         Delete      </el-button> -->
                            </span>
                          </span>
                        
                    </el-tree>

                </div>
            </div>
            <div class="rightContent">
               <div class="btnWrap">
                    <div class="btnBox">
                        <el-button  @click="currentBtnAction='add'" class="toggleBtn" :class="{active:currentBtnAction=='add'}" 
                        v-if="currentChoseNode.menu_parent_id==0">
                            新增菜单  <i class="el-icon-plus"></i></el-button> 
                        <el-button  @click="currentBtnAction='edit'" class="toggleBtn" :class="{active:currentBtnAction=='edit'}" 
                        v-if="currentChoseNode.menu_id!='root'">
                            编辑菜单 <i class="el-icon-edit"></i> </el-button> 
                        <el-button  @click="currentBtnAction='delete'" class="toggleBtn" :class="{active:currentBtnAction=='delete'}"  
                        v-if="currentChoseNode.menu_id!='root'">
                            删除菜单 <i class="el-icon-delete"></i></el-button> 
                   </div>
               </div>
              
                <div class="formWrap" :class="{add:currentBtnAction=='add',edit:currentBtnAction=='edit',delete:currentBtnAction=='delete',}" >
                    <div class="currentNodeBox">
                        <div class="currentNodeMsg noNode" v-if="!currentChoseNode.menu_name">
                            <span class="red">请先选择要操作的菜单</span>
                        </div>
                        <div class="currentNodeMsg" v-if='currentChoseNode.menu_name'>
                            <span class="spanItem">当前选择的菜单节点:</span> 
                            <span class="blue name">{{currentChoseNode.menu_name}}</span>
                            <span class="spanItem"> 当前ID:{{currentChoseNode.menu_id}}</span>
                            <span class="spanItem">他的父节点;{{currentChoseNode.menu_parent_id}}</span>
                        </div>
                    </div>
                     <div class="formBlock" v-if="currentBtnAction=='add'">
                        <el-form :model="addNodeArg" :rules="rules" ref="addNodeForm" label-width="100px">
                            <el-form-item label="当前ID" prop="name">
                                  系统自动生成 
                            </el-form-item>
                            <el-form-item label="父节点ID" prop="menuParentId" >
                                 <el-input type="text" v-model="addNodeArg.menuParentId" disabled="disabled"> </el-input>
                            </el-form-item>
                            <el-form-item label="当前系统平台" prop="menuSysId" >
                                 <el-input type="text" v-model="addNodeArg.menuSysId" disabled="disabled"> </el-input>
                            </el-form-item>
                             <el-form-item label="菜单名字" prop="menuName" required>
                                 <el-input type="text" v-model="addNodeArg.menuName" placeholder="如:订单管理"> </el-input>
                            </el-form-item>
                            <el-form-item label="菜单路径" prop="menuRequestUrl" required>
                                    <el-input type="text" v-model="addNodeArg.menuRequestUrl" placeholder="如:/orderList" > </el-input>
                            </el-form-item>
                            <el-form-item label="菜单顺序" required  prop="menuSequence">
                                <el-input type="text" v-model.number="addNodeArg.menuSequence" > </el-input>
                            </el-form-item>
                            <el-form-item label="icon"  class="iconInputLine">
                                 <div class="btnLine">
                                     <el-input type="text" v-model="addNodeArg.menuIcon" > </el-input>
                                     <el-button class="rightBtn" @click="isShowAddIcon=!isShowAddIcon">
                                         图标面板
                                        <span v-if="!isShowAddIcon"> <i class="el-icon-caret-right"></i> </span>
                                        <span v-if="isShowAddIcon"> <i class="el-icon-caret-bottom"></i> </span>
                                         
                                     </el-button>
                                 </div>
                                <div class="iconPanelWrap" v-if="isShowAddIcon">
                                    <div class="iconBlock" :class="{active:addNodeArg.menuIcon==iconList}" v-for="(iconList,indexIcon) in icon_word_arr" @click="choseIcon(iconList,'add')">
                                        <i :class="iconList"></i>
                                    </div>
                                </div>
                            </el-form-item>
                           <!-- <el-form-item label="key" prop="key" required>
                                   <el-input type="text" v-model="addNodeArg.key"  placeholder="如:orderList" > </el-input>
                            </el-form-item> -->
                           <el-form-item label="状态"   prop="menuState">
                               <el-input type="text" v-model="addNodeArg.menuState" disabled="disabled"> </el-input>
                               <!-- <el-radio v-model="addNodeArg.menuState" label="y">是</el-radio>
                                <el-radio v-model="addNodeArg.menuState" label="n">否</el-radio> -->
                            </el-form-item>
                            <el-form-item  >
                                 <el-button @click="addNode('addNodeForm')" type="primary" v-if="functionAddMenu">确定新增</el-button> 
                            </el-form-item>
                         </el-form>
                    </div>
                    
                    <div class="formBlock" v-if="currentBtnAction=='edit'">
                        <el-form :model="editNodeArg" :rules="rules"  ref="editNodeForm" label-width="100px">
                             <el-form-item label="当前ID" prop="name">
                                  <el-input type="text" v-model="editNodeArg.menuId" disabled="disabled"> </el-input>
                            </el-form-item>
                            <el-form-item label="父节点ID" prop="menuParentId" >
                                 <el-input type="text" v-model="editNodeArg.menuParentId" disabled="disabled"> </el-input>
                            </el-form-item>
                            <el-form-item label="当前系统平台" prop="menuSysId" >
                                 <el-input type="text" v-model="editNodeArg.menuSysId" disabled="disabled"> </el-input>
                            </el-form-item>
                            <el-form-item label="菜单名字" prop="menuName" required>
                                 <el-input type="text" v-model="editNodeArg.menuName" placeholder="如:订单管理"> </el-input>
                            </el-form-item>
                            <el-form-item label="菜单路径" prop="menuRequestUrl" required>
                                    <el-input type="text" v-model="editNodeArg.menuRequestUrl" placeholder="如:/orderList"> </el-input>
                            </el-form-item>
                            <el-form-item label="菜单顺序" required  prop="menuSequence">
                                <el-input type="text" v-model.number="editNodeArg.menuSequence" placeholder="如:2"> </el-input>
                            </el-form-item>
                            <el-form-item label="icon"   class="iconInputLine">
                                 <div class="btnLine">
                                    <el-input type="text" v-model="editNodeArg.menuIcon" > </el-input>
                                    <el-button class="rightBtn" @click="isShowEditIcon=!isShowEditIcon">
                                        图标面板
                                        <span v-if="!isShowEditIcon"> <i class="el-icon-caret-right"></i> </span>
                                        <span v-if="isShowEditIcon"> <i class="el-icon-caret-bottom"></i> </span>
                                    </el-button>
                                </div>
                                <div class="iconPanelWrap" v-if="isShowEditIcon">
                                    <div class="iconBlock" :class="{active:editNodeArg.menuIcon==iconList}" v-for="(iconList,indexIcon) in icon_word_arr" @click="choseIcon(iconList,'edit')">
                                        <i :class="iconList"></i>
                                    </div>
                                </div>
                            </el-form-item>
                           <!-- <el-form-item label="key" prop="key" required>
                                   <el-input type="text" v-model="editNodeArg.key"  placeholder="如:orderList"> </el-input>
                            </el-form-item> -->
                            <el-form-item label="状态"   prop="menuState">
                                <el-input type="text" v-model="editNodeArg.menuState" disabled="disabled"> </el-input>
                              <!--  <el-radio v-model="editNodeArg.menuState" label="y">是</el-radio>
                                <el-radio v-model="editNodeArg.menuState" label="n">否</el-radio> -->
                            </el-form-item>
                            <el-form-item  >
                                 <el-button @click="editNode('editNodeForm')" type="primary" v-if="functionEditMenu">确定编辑</el-button> 
                            </el-form-item>
                         </el-form>
                    </div>
                    <div class="formBlock" v-if="currentBtnAction=='delete'">
                        <ul>
                            <li>这里删除当前节点菜单的表单</li>
                            <li> <span class="redStar">*</span> <span class="label">父节点ID</span>       <input type="text" v-model="deleteNodeArg.menuParentId" disabled="disabled"> </li>                            
                            <li> <span class="redStar">*</span> <span class="label">当前ID</span>         <input type="text" v-model="deleteNodeArg.menuId" disabled="disabled"> </li>                            
                            <li>  <span class="redStar">*</span> <span class="label">菜单名字</span>       <input type="text" v-model="deleteNodeArg.menuName" disabled="disabled">                           </li>                            
                            <li>
                                <el-button @click="deleteNode" type="primary" v-if="functionDeleteMenu">确定删除</el-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import {json,wordData,utils} from '@/common/common.js'
    import {ajaxPost, api} from '@/common/request.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
                isLoadingMenu:false,
                isShowAddIcon:false,
                isShowEditIcon:false,
                isShowTree:true,
                currentBtnAction:'add',
                currentChoseNode:{},
                addNodeArg:{
                    menuIcon:'',
                },
                editNodeArg:{
                    menuIcon:'',
                },
                deleteNodeArg:{},
                allMenuData:[],
                defaultProps: {
                  children: 'subMenu',
                  label: 'menu_name'
                },
                rules:{
                     menuSequence: [
                        { required: true, message: '请填写顺序', trigger: 'change' },
                        {type: 'number', message: '顺序为数字值', trigger: 'change'}
                      ],
                }
            }
        },
        computed: {
            functionAddMenu(){
                return utils.getCurrentFunction().indexOf("leftMenu_addMenu")>-1
            },
            functionEditMenu(){
                return utils.getCurrentFunction().indexOf("leftMenu_editMenu")>-1
            },
            functionDeleteMenu(){
                return utils.getCurrentFunction().indexOf("leftMenu_deleteMenu")>-1
            },
            adminId() {
                return utils.getAdminId()
            },
            
            icon_word_arr(){
                return wordData.icon_word
            },
        },
        methods: {
            toggleMenuState(data){
               let _this=this
              let arg={
                  menuId:data.menu_id,
                  adminId:_this.adminId
              }
              ajaxPost('/admin/menu/updateMenuStatus',arg).then(function(res){
                  if(res.errorCode==200){
                      _this.refreshPage()
                  }else{
                  }
                      
              },function(res){
              })
              
            },
            choseIcon(list,type){
                if(type=='edit'){
                     this.editNodeArg.menuIcon=list
                     this.isShowEditIcon=false

                }
                 if(type=='add'){
                     this.addNodeArg.menuIcon=list
                     this.isShowAddIcon=false
                }
             
            },
            deleteNode(){
                let _this=this
                if(!_this.deleteNodeArg.menuId){
                    _this.$message({
                        message: "未选择删除节点", 
                        type: 'error',
                   }); 
                   return false
                }else{
                    if(!confirm("确认删除 ' "+ _this.deleteNodeArg.menuName+ " ' 吗？")){
                        return false
                    }
                     ajaxPost('/admin/menu/editMenuByMid',_this.deleteNodeArg).then(function(res){
                        if(res.errorCode==200){
                             _this.$message({
                            	message: "删除成功", 
                            	type: 'success',
                                duration:1000
                            });
                            _this.refreshPage()
                        }else{
                             _this.$message({
                            	message: res.errorMsg, 
                            	type: 'error',
                            });
                        }
                            
                    },function(res){
                    })
                }
               
            },
            editNode(formName){
                 let _this=this
                console.log(_this.editNodeArg)
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(!confirm("确认修改 ' "+ _this.editNodeArg.menuName+ " ' 吗？")){
                            return false
                        }
                        ajaxPost('/admin/menu/editMenu',_this.editNodeArg).then(function(res){
                            if(res.errorCode==200){
                                 _this.$message({
                                	message: "修改成功", 
                                	type: 'success',
                                    duration:1000
                                });
                                _this.refreshPage()
                            }else{
                                 _this.$message({
                                	message: res.errorMsg, 
                                	type: 'error',
                                });
                            }
                                
                        },function(res){
                        })
                    }
                })
            },
            addNode(formName){
                let _this=this
                console.log(_this.addNodeArg)
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(!confirm("确认增加 ' "+ _this.addNodeArg.menuName+ " ' 吗？")){
                            return false
                        }
                        ajaxPost('/admin/menu/addMenu',_this.addNodeArg).then(function(res){
                            if(res.errorCode==200){
                                 _this.$message({
                                	message: "增加成功", 
                                	type: 'success',
                                    duration:1000
                                });
                                _this.refreshPage()
                            }else{
                                 _this.$message({
                                	message: res.errorMsg, 
                                	type: 'error',
                                });
                            }
                                
                        },function(res){
                        })
                    }
                })
            },
            addNodeFromRoot(){
                let _this=this
                this.isShowTree=false
                this.currentBtnAction='add'
                this.addNodeArg={
                   "menuName":'',
                   "menuState":'y',
                   "menuParentId":0,
                   "menuRequestUrl":'',
                   "adminId":_this.adminId,
                   "menuSequence":'',
                   "menuIcon":'',
                   "menuSysId":utils.getSysId(),
               } 
               this.currentChoseNode={
                   menu_name:"根菜单",
                   menu_id:'root',
                   menu_parent_id:0,
               }
            },
            ceshi() {
                let _this = this
            },
            handleNodeClick(data) {
                let _this=this
                console.log(data)
                this.currentChoseNode=data
                this.currentBtnAction='edit'
                _this.addNodeArg={
                    "menuName":'',
                    "menuState":'y',
                    "menuParentId":data.menu_id,
                    "menuRequestUrl":'',
                    "adminId":_this.adminId,
                    "menuSequence":'',
                    "menuIcon":'',
                    "menuSysId":utils.getSysId(),
                }
                _this.editNodeArg={
                    "menuName":data.menu_name,
                    "menuState":data.menu_state,
                    "menuId":data.menu_id,
                    "menuParentId":data.menu_parent_id,
                    "menuRequestUrl":data.menu_request_url,
                    "adminId":_this.adminId,
                    "menuSequence":data.menu_sequence,
                    "menuIcon":data.menu_icon,
                    "menuSysId":utils.getSysId(),
                }
                _this.deleteNodeArg={
                    "menuName":data.menu_name,
                    "menuParentId":data.menu_parent_id,
                    "menuId":data.menu_id,
                    "adminId":_this.adminId,
                }
                //  addNodeArg:{},
                // editNodeArg:{},
                // deleteNodeArg:{},
            },
            getActiveMenu(){
                let _this=this
                let arg={
                    menuSysId:utils.getSysId(), 
                }
                this.isLoadingMenu=true
                ajaxPost('/admin/menu/menuList',arg).then(function(res){
                    // if(res.errorCode==200){
                    //      _this.isLoadingMenu=false
                    //     _this.allMenuData=res.data
                    // }else{
                    //      _this.isLoadingMenu=false
                    // }
                },function(res){
                })
            },
            getAllMenu(){
                let _this=this
                let arg={
                    menuSysId:utils.getSysId(),  
                }
                this.isLoadingMenu=true
                ajaxPost('/admin/menu/findAllMenuList',arg).then(function(res){
                    if(res.errorCode==200){
                        setTimeout(function(){
                             _this.isLoadingMenu=false
                        },50)
                        
                        _this.allMenuData=res.data
                    }else{
                         setTimeout(function(){
                             _this.isLoadingMenu=false
                        },50)
                    }
                },function(res){
                })
            },
            refreshPage(){
                this.getAllMenu()
            }
        },
        mounted() {
            let _this = this
            this.getAllMenu()
            // this.leftMenu=utils.getItem("leftMenu")?JSON.parse(utils.getItem("leftMenu")):[]
            // console.log(this.leftMenu,'菜单管理 里的mouted 的菜单')

        }
    }
</script>

<style scoped lang="scss">
    // *{outline:1px solid red}
    .leftMenuManagerWrap{
        background: #eee;
        .mainContent{
            padding:5px 10px;
        }
        .iconInputLine{
            .btnLine{
                position: relative;
                .rightBtn{
                    position: absolute;top:0;right:0;
                }
            }
            .iconPanelWrap{
                z-index:100;
                box-shadow:0 0 5px #8bbae2 ; padding:20px; position: absolute; right:0px;top:50px; background: #ddf;
                .iconBlock{
                    display: inline-block;width: 50px;text-align: center;border:1px solid #fff; background: #ddf;
                }
                .iconBlock:hover,.iconBlock.active{background: #2B87D6;cursor: pointer;}
            }
            
        }
        
        .hrLine{border:1px dotted #ddd;margin:20px 0;}
        .toggleBtn{border-radius: 0;border:1px solid #fff;}
        .toggleBtn.active{border:1px solid #8bbae2;background: #8bbae2;color:#fff; }
        .rootBtnBox{padding:10px;cursor: pointer;}
        .rootBtnBox:hover{background: #2B87D6;color:#fff;}
        .rootBtnBox:active{background: #2B87D6;color:#fff;}
        .mainContent{
            display: flex; min-height:750px;
            .treeMenuBox{
                background: #fff;;
                 width: 250px; padding:5px;
                 .rootLine{
                     color:#999;font-size: 16px; background: #efeef;cursor:pointer;
                     padding:15px 0 15px 10px; position: relative; margin-bottom: 10px;
                     .spanBtn{position: absolute; right:10px;top:3px;}
                 }
                 .rootLine:hover{background: #8bbae2;color:#fff;}
                 .rootLine.active{background: #215079;color:#fff}
                 .treeBox{
                     
                 }
                 .textBtn{margin-left:10px;font-size: 12px;}
            }
            .rightContent{
                padding:0 10px; background: #fff; margin-left: 10px; flex:1;
                .btnBox{padding-top:20px; }
                .currentNodeBox{
                    padding:20px 10px 0px;
                    font-size: 15px;
                    .currentNodeMsg{  
                        padding-bottom:10px; border-bottom: 1px dotted #ddd; margin-bottom: 20px;
                        .name{font-size: 20px;}
                    }
                }
                .formWrap{
                    padding:10px;  background: #fff; border:1px solid  #8bbae2;  
                    .formBlock{  width: 400px; text-align: left; display: inline-block;
                        li{padding:5px 0 5px 10px;position: relative;}
                        input{border:1px solid #bebebe;border-radius: 4px;padding:5px;}
                        .label{display: inline-block;width: 100px;}
                        .redStar{position: absolute;left:0;top:10px;}
                    
                    }
                }
                .formWrap.add{  }
                .formWrap.edit{  }
                .formWrap.delete{ }
            }
        }
        
    }
</style>



// WEBPACK FOOTER //
// src/pages/system/leftMenuManager.vue